import React from 'react'
import { buildQuery } from './graphql'
import type { InlineInputProps } from '@ztechapps/webui.input'
import { InlineInput } from '@ztechapps/webui.input'

export const CustomerInlineInput = ({
  parentInputComponent,
  name,
  mutationConfig,
  query,
  ...rest
}: InlineInputProps & { query?: string }) => {
  const ParentInput = parentInputComponent || InlineInput

  const defaultMutationConfig = React.useMemo(() => {
    if (query) return buildQuery(query).updateConfig

    return buildQuery(name).updateConfig
  }, [name, query])

  return <ParentInput {...{ name, mutationConfig: mutationConfig ?? defaultMutationConfig, ...rest }} />
}
